import CustomChannel from ".";

export const customChannelRoutes = [
  {
    path: "/customChannel",
    element: <CustomChannel />,
  },
];
